<template lang="pug">
  el-form(label-width="80px" label-suffix=":" :rules="rules" :model="role" ref="form")
    el-form-item(label="角色" v-if="!noSave" prop="roleDescription")
      el-input(v-model="role.roleDescription")
    el-form-item(label="城市" v-if="!noSave" prop="cityGuids")
      el-select(v-model="role.cityGuids" filterable multiple)
        el-option(
          v-for="city in cityList"
          :label="city.cityName"
          :value="city.cityGuid"
          :key="city.cityGuid"
        )
    el-form-item(label="权限")
      el-tree(
        ref="tree"
        :props="props"
        :data="permissionList"
        show-checkbox
        :default-expanded-keys="expandedKeys"
        node-key="id"
      )
    el-form-item(v-if="!noSave")
      el-button(type="success" @click="submit") 保存
</template>

<script>
import { getUserPermission, getPermissionList, changePermission, getCityList } from '@/api/user';

export default {
  name: 'PermissionTree',
  props: {
    id: {
      default: null,
      type: [Number, String]
    },
    data: {
      default: () => {},
      type: Object
    },
    noSave: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      props: {
        label: 'description',
        children: 'children',
      },
      userPermission: [],
      permissionList: [],
      expandedKeys: [],
      loading: false,
      cityList: [],
      role: {
        roleDescription: null,
        cityGuids: []
      },
      rules: {
        roleDescription: [{ required: true, message: '请输入角色名', trigger: 'blur' }],
        cityGuids: [{ required: true, message: '请选择城市', trigger: 'change' }],
      }
    };
  },
  mounted() {
    if (!this.noSave) {
      this.role = this.data ? { ...this.data } : this.role;
      this.getCityList();
    }
    this.getPermissionList();
  },
  methods: {
    async getPermissionList() {
      const res = await getPermissionList();
      this.permissionList = res.data || [];
      this.expandedKeys = res.data.map(x => x.id);
      if (this.role.id || this.id) {
        const user = await getUserPermission({ roleId: this.role.id || this.id });
        this.$nextTick(() => {
          const nodes = user.data.filter(x => (this.$refs.tree.getNode(x) || {}).isLeaf);
          this.$refs.tree.setCheckedKeys(nodes);
        });
      }
    },
    async getCityList() {
      const res = await getCityList();
      this.cityList = res.data || [];
    },
    submit() {
      this.$refs.form.validate(async (flag) => {
        if (flag) {
          const data = {
            id: this.role.id,
            cityGuids: this.role.cityGuids,
            roleDescription: this.role.roleDescription,
            permissionIds: [
              ...this.$refs.tree.getCheckedKeys(),
              ...this.$refs.tree.getHalfCheckedKeys()
            ]
          };
          const res = await changePermission(data);
          if (res.status === 1) {
            this.$message.success('保存权限成功');
            this.$emit('submit');
          } else {
            this.$message.success(res.info);
          }
        }
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/system/permissionTree.vue?09c24a1a